import { DocumentNode, gql } from "@apollo/client";

class ProfileService {
  public static getProfile = (): DocumentNode => gql`
    query GetProfile {
      getProfile {
        uid
        firstName
        middleName
        lastName
        alternativeLastName
        dateOfBirth
        email
        phone
        ethnicities {
          ethnicityTypes {
            code
            description
          }
          subEthnicity
        }
        addresses {
          uid
          countryCode
          city
          state
          street1
          street2
          zipCode
        }
        communicationPreferences {
          channelType
          value
          optedIn
        }
      }
    }
  `;

  public static getPatientBasicInfo = (): DocumentNode => gql`
    query GetPatientBasicInfo {
      getPatientBasicInfo {
        firstName
        middleName
        lastName
        phone
        email
        addresses {
          uid
          countryCode
          city
          state
          street1
          street2
          zipCode
        }
        dateOfBirth
      }
    }
  `;

  public static verifyProfileByToken = (): DocumentNode => gql`
    mutation VerifyProfileByToken($dateOfBirth: String!, $token: String!) {
      verifyProfileByToken(dateOfBirth: $dateOfBirth, token: $token) {
        isVerified
        intentToken
      }
    }
  `;

  public static setupProfile = (): DocumentNode => gql`
    mutation SetupProfile($profileData: SetupProfileDTO!) {
      setupProfile(profileData: $profileData) {
        uid
        firstName
        middleName
        lastName
        alternativeLastName
        dateOfBirth
        birthGender
        email
        phone
        language {
          code
        }
      }
    }
  `;

  public static confirmProfile = (): DocumentNode => gql`
    mutation ConfirmProfile($profileData: SetupProfileDTO!) {
      confirmProfile(profileData: $profileData) {
        uid
        firstName
        middleName
        lastName
        dateOfBirth
      }
    }
  `;

  public static updatePersonalInformation = (): DocumentNode => gql`
    mutation UpdatePersonalInformation($personalInformation: SetupProfileDTO!) {
      updatePersonalInformation(personalInformation: $personalInformation) {
        uid
        firstName
        middleName
        lastName
        alternativeLastName
      }
    }
  `;

  public static addPatientAddress = (): DocumentNode => gql`
    mutation AddPatientAddress(
      $patientAddress: AddressCommonDTO!
      $heapEventLocation: String
    ) {
      addPatientAddress(
        patientAddress: $patientAddress
        heapEventLocation: $heapEventLocation
      ) {
        uid
        countryCode
        city
        state
        street1
        street2
        zipCode
      }
    }
  `;

  public static updatePatientAddress = (): DocumentNode => gql`
    mutation UpdatePatientAddress($patientAddress: AddressDTO!) {
      updatePatientAddress(patientAddress: $patientAddress) {
        uid
        countryCode
        city
        state
        street1
        street2
        zipCode
      }
    }
  `;

  public static addPatientEthnicities = (): DocumentNode => gql`
    mutation addPatientEthnicities(
      $patientEthnicities: PatientEthnicitiesDTO!
    ) {
      addPatientEthnicities(patientEthnicities: $patientEthnicities) {
        uid
      }
    }
  `;

  public static updatePatientCommunication = (): DocumentNode => gql`
    mutation UpdatePatientCommunication(
      $patientCommunication: [CommunicationDTO!]!
      $communicationPayload: UpdateCommunicationPayload
    ) {
      updatePatientCommunication(
        patientCommunication: $patientCommunication
        communicationPayload: $communicationPayload
      ) {
        channelType
        value
      }
    }
  `;

  public static sendPhoneNumberVerificationCode = () => gql`
    mutation SendPhoneNumberVerificationCode($phoneNumber: String!) {
      sendPhoneNumberVerificationCode(phoneNumber: $phoneNumber) {
        success
      }
    }
  `;

  public static updatePatientPhoneNumber = () => gql`
    mutation UpdatePatientPhoneNumber($verificationCode: String!) {
      updatePatientPhoneNumber(verificationCode: $verificationCode) {
        success
      }
    }
  `;

  public static updatePatientLanguage = (): DocumentNode => gql`
    mutation UpdatePatientLanguage($language: String!, $token: String) {
      updatePatientLanguage(language: $language, token: $token) {
        success
      }
    }
  `;
}

export default ProfileService;
